/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";
import NewSelectInput from "../../../components/NewSelectInput";
import ListView from "../../../components/common/ListView";
import TextareaField from "../../../components/common/TextareaField";
import { useState } from "react";

const inventoryData = [
  {
    id: 1,
    awb: "654654654654",
    status: "Out for delivery",
  },
  {
    id: 2,
    awb: "654654654654",
    status: "Dispatch",
  },
  {
    id: 3,
    awb: "654654654654",
    status: "Delivered",
  },
  {
    id: 4,
    awb: "654654654654",
    status: "Undelivered",
  },
  {
    id: 5,
    awb: "654654654654",
    status: "Undelivered",
  },
];

const BulkStatusRevertModal = () => {
  const [awbText, setAwbText] = useState("");

  return (
    <div className="w-full py-4 pr-2 space-y-4 bg-[#F7F6F2] rounded-r-[30px] rounded-bl-[30px]">
      <div className="grid grid-cols-2 gap-6">
        <div className="bg-[#FCFDF8] rounded-xl p-4 space-y-4">
          <div className="bg-[#FCFDF8] border-[1.5px] border-[#D2D2D2] rounded-xl p-6 ">
            <textarea
              rows={8}
              className="w-full h-full resize-none outline-none bg-transparent text-xs text-[#212121]/70"
              placeholder="Paste AWB numbers here (each AWB must be space or list separated)"
              value={awbText}
              onChange={(e) => setAwbText(e.target.value)}
            />
          </div>
          <NewSelectInput label="Choose Status" name={""} selectOptions={[]} />
          <TextareaField
            rows={4}
            label={"Reason"}
            placeholder={"Enter Reason"}
            name={""}
          />
          <button
            type="button"
            className="bg-[#FBD037]  text-black text-sm font-medium px-6 py-2 rounded-full shadow-sm hover:bg-[#d1a306] transition"
          >
            Submit
          </button>
        </div>
        <div className="bg-[#FCFDF8] rounded-xl p-4 space-y-4">
          <div className="">
            <h2 className="text-[#000000] text-xl">Orders Status</h2>
          </div>

          <ListView
            mailDivClassName="w-full  border"
            mainDivClassName="bg-[#FCFDF8]"
            trClassName="hover:bg-[#FBD037]/20 group"
            tdClassName="rounded-r-none rounded-l-none"
            data={inventoryData}
            columns={[
              {
                label: "#",
                render: (_: any, i: number) => i + 1,
              },
              {
                label: "AWB",
                render: (c) => c.awb,
              },
              {
                label: "Status",
                render: (c) => {
                  const getStatusClasses = (status: string) => {
                    switch (status) {
                      case "Out for delivery":
                      case "Dispatch":
                        return "bg-[#EBF7CE] text-[#212121]";
                      case "Delivered":
                        return "bg-[#EEEEEE] text-[#212121]";
                      case "Undelivered":
                        return "bg-[#F7E9CE] text-[#212121]";
                      default:
                        return "bg-gray-300 text-black";
                    }
                  };
                  return (
                    <button
                      className={`rounded-full px-4 py-1 text-center ${getStatusClasses(
                        c.status
                      )}`}
                    >
                      {c.status}
                    </button>
                  );
                },
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default BulkStatusRevertModal;
